import {EquipmentData} from '@domain/shifthandover'
import {KpiOption as DropdownOption} from '@hconnect/common/types'
import {getEquipmentIdType} from '@hconnect/common/utils'
import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_FILTERS_WIDGET_NAMESPACE} from '../consts'

import {EquipmentSearchField} from './EquipmentSearchField'
import {MainEquipmentSearchField} from './MainEquipmentSearchField'
import {StoppedMainEquipmentField} from './StoppedMainEquipmentField'

type EquipmentFiltersProps = {
  visibleFilters: string[]
  removeFilter: (filterName: string) => void
  plantId: string
  equipment?: EquipmentData
  onEquipmentChange?: (equipment?: EquipmentData) => void
  mainEquipment?: EquipmentData
  onMainEquipmentChange?: (mainEquipment?: EquipmentData) => void
  functionalEquipment?: EquipmentData
  onFunctionalEquipmentChange?: (functionalEquipment?: EquipmentData) => void
  stoppedMainEquipment?: DropdownOption
  onStoppedMainEquipmentChange?: (stoppedMainEquipment?: DropdownOption) => void
}

export const EquipmentFilters: FC<EquipmentFiltersProps> = ({
  visibleFilters,
  removeFilter,
  plantId,
  equipment,
  onEquipmentChange,
  mainEquipment,
  onMainEquipmentChange,
  functionalEquipment,
  onFunctionalEquipmentChange,
  stoppedMainEquipment,
  onStoppedMainEquipmentChange
}) => {
  const {t} = useTranslation(SHIFT_EVENT_FILTERS_WIDGET_NAMESPACE)
  const shouldShowExtendedEquipmentId = useCommonFeatureFlag(FeatureFlagKey.ExtendedEquipmentIds, {
    plantId
  })
  const shouldShowStoppedMainEquipment = useCommonFeatureFlag(FeatureFlagKey.StoppedMainEquipment)
  const equipmentIdType = getEquipmentIdType(!!shouldShowExtendedEquipmentId)

  return (
    <>
      {shouldShowStoppedMainEquipment &&
        visibleFilters.includes('stoppedMainEquipment') &&
        onStoppedMainEquipmentChange && (
          <StoppedMainEquipmentField
            plantId={plantId}
            data-test-id="events-filter-bar-stopped-main-equipment"
            onChange={onStoppedMainEquipmentChange}
            value={stoppedMainEquipment}
            removeFilter={removeFilter}
          />
        )}
      {visibleFilters.includes('equipment') && onEquipmentChange && (
        <EquipmentSearchField
          data-test-id={'events-filter-bar-equipment'}
          onChange={onEquipmentChange}
          value={equipment}
          removeFilter={removeFilter}
          idType={equipmentIdType}
          plantId={plantId}
        />
      )}
      {visibleFilters.includes('mainEquipment') && onMainEquipmentChange && (
        <MainEquipmentSearchField
          data-test-id={'events-filter-bar-mainEquipment'}
          onChange={onMainEquipmentChange}
          value={mainEquipment}
          removeFilter={removeFilter}
          label={t('shiftEvent.label.mainEquipment')}
          idType={equipmentIdType}
          plantId={plantId}
        />
      )}
      {visibleFilters.includes('functionalEquipment') && onFunctionalEquipmentChange && (
        <MainEquipmentSearchField
          data-test-id={'events-filter-bar-functionalEquipment'}
          onChange={onFunctionalEquipmentChange}
          value={functionalEquipment}
          removeFilter={removeFilter}
          label={t('shiftEvent.label.functionalEquipment')}
          plantId={plantId}
        />
      )}
    </>
  )
}
